const images = document.querySelectorAll("[data-src]");

function preloadImage(img){
    const src = img.getAttribute("data-src");
    if(!src){
        return;
    }

    img.src = src;
}

const imgOptions = {
    threshold: 0,
    rootMargin: "0px 0px 300px 0px "
};

const imgObserver = new IntersectionObserver((entries, imgObserver) => {
    entries.forEach(entery => {
        if(!entery.isIntersecting){
            return;
        }else {
            preloadImage(entery.target);
            imgObserver.unobserve(entery.target);
        }
    })
}, imgOptions);

images.forEach(image => {
    imgObserver.observe(image);
});


//Review Slider

$('.review-slider').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
        {
            breakpoint: 1290,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
            }
        },
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                variableWidth: true,
                centerMode: true
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true,
                centerMode: true
            }
        }
    ]

}); 

$('.imageSlider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    centerMode: true,
    variableWidth: true,
    responsive: [
        {
            breakpoint: 749,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                variableWidth: true,
                centerMode: true
            }
        }
    ]
});

$('.slider-blog').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
        {
            breakpoint: 1265,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true,
                variableWidth: true,
                centerMode: true
            }
        },
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                variableWidth: true,
                centerMode: true
            }
        },
        {
            breakpoint: 749,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true,
                centerMode: true
            }
        }
    ]
});
$('.cateory-title ').click(function(){
    $('.cateory-title ').removeClass('active');
    $(this).addClass('active');
    $(`.slider-section`).removeClass('active')
    $(`.slider-section[data-slider='${$(this).attr('data-index')}']`).addClass('active')
})


//module
$('.module-container').click(function(){
    $(this).toggleClass('active');
});
function ApplyJavascript(){
    $('#ModuleConatiner').remove();
    let StyleTage = ``;
    if(screen.width <= 1024){
        StyleTage = StyleTage + `.module-container {
            height: ${convertPXToVW(40)}px;
        }`
    }else {
        StyleTage = StyleTage + `.module-container {
            height: ${convertPXToVW(16)}px;
        }`
    }
    for(let i = 0; i < $('.module-container').length ; i++){
        console.log($($('.module-container')[i]).outerHeight() , (convertPXToVW(40) + 4))
        if(screen.width <= 1024){
            if($($('.module-container')[i]).outerHeight() <= convertPXToVW(60) + 4){
                StyleTage = StyleTage + `
                    .module-container${i}.active{
                        height: ${convertPXToVW(60)}px !important;
                    }`
            }else {
                StyleTage = StyleTage + `
                    .module-container${i}.active{
                        height: ${$($('.module-container')[i]).outerHeight() + 50}px !important;
                    }`
            }
        }else {
            if($($('.module-container')[i]).outerHeight() <= convertPXToVW(32) + 4){
                StyleTage = StyleTage + `
                    .module-container${i}.active{
                        height: ${convertPXToVW(32)}px !important;
                    }`
            }else {
                StyleTage = StyleTage + `.module-container${i}.active{
                        height: ${$($('.module-container')[i]).outerHeight() + 50 }px !important;
                    }`
            }
        }
        
    }
    
    $('body').append(`<style id="ModuleConatiner">
        ${StyleTage}
    </style>`)
}


ApplyJavascript();


function convertPXToVW(vw) {
	return  (document.documentElement.clientWidth * vw ) / 100;
}

(()=>{
  $('.slider-all-box .slick-next').click()  
  setTimeout(() => {
    $('.slider-all-box .slick-next').click()  
    setTimeout(() => {
        $('.slider-all-box .slick-next').click()  
        setTimeout(() => {
            $('.slider-all-box .slick-next').click()  
          }, 1000);
      }, 1000);
  }, 1000);
})();